<template>
  <div class="m-card-thumbnail">
    <template v-if="href">
      <a v-bind="linkProps">
        <ResponsiveImage
          :lazy="lazy"
          :path="path"
          :absolute-url="absoluteUrl"
          :alt="alt"
          srcset-sizes="(max-width: 576px) 50vw, (max-width: 768px) 25vw, 33vw"
        />
      </a>
    </template>
    <template v-else>
      <ResponsiveImage
        :lazy="lazy"
        :path="path"
        :absolute-url="absoluteUrl"
        :alt="alt"
        srcset-sizes="(max-width: 576px) 50vw, (max-width: 768px) 25vw, 33vw"
      />
    </template>
  </div>
</template>

<script>
import ResponsiveImage from './../../Utils/ResponsiveImage'

export default {
  name: 'CardThumbnail',
  components: {
    ResponsiveImage
  },
  props: {
    alt: {
      type: String,
      default: ''
    },
    path: { // will be used with cloudfrontPattern to generate srcset
      type: String,
      default: ''
    },
    absoluteUrl: { // will be used instead of path/cloudfronPattern
      type: String,
      default: ''
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    href () {
      return this.$parent.$props.href ?? false
    },
    linkProps () {
      const props = {
        href: this.href
      }

      if (this.href && this.$parent.$props.external) {
        props.target = '_blank'
      }

      return props
    }
  }
}
</script>
